import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Line from './Line';

const LineIcon = props => (
    <IconFromPath {...props} Path={Line} />
);

export default LineIcon;
